import { apiClient } from './client';

export interface RecentObservationItem {
  id: string;
  child_name: string;
  teacher_name: string;
  category: string | null;
  observation_date: string;
  narrative: string;
}

export interface RecentAssessmentItem {
  id: string;
  child_name: string;
  learning_area_name: string | null;
  score: number;
  assessment_date: string;
}

/**
 * Org-wide aggregates returned by `GET /dashboard/admin-stats`.
 *
 * Admin-only endpoint -- a teacher token gets 403. The numbers describe
 * the school: total children enrolled, every observation/assessment the
 * org has produced, every active classroom, every active teacher.
 */
export interface AdminDashboardStats {
  total_children: number;
  total_observations: number;
  total_assessments: number;
  total_classrooms: number;
  total_teachers: number;
  observations_this_week: number;
  recent_observations: RecentObservationItem[];
  recent_assessments: RecentAssessmentItem[];
}

/**
 * Caller-scoped numbers returned by `GET /dashboard/teacher-stats`.
 *
 * "Mine" means children in classrooms the caller actively teaches plus
 * observations the caller authored. Assessments scope by classroom (the
 * Assessment model has no author column today).
 */
export interface TeacherDashboardStats {
  my_children: number;
  my_observations: number;
  my_assessments: number;
  my_observations_this_week: number;
  my_classrooms: number;
  recent_observations: RecentObservationItem[];
  recent_assessments: RecentAssessmentItem[];
}

export const dashboardApi = {
  async getAdminStats(): Promise<AdminDashboardStats> {
    const response = await apiClient.get('/dashboard/admin-stats');
    return response.data;
  },

  async getTeacherStats(): Promise<TeacherDashboardStats> {
    const response = await apiClient.get('/dashboard/teacher-stats');
    return response.data;
  },
};
